import React from 'react';
import './ReportHeader.css';

const ReportHeader = () => {
  return (
    <div className="report-header-container">
      <div className="report-header-content">
        <div className="report-header-text">
          <h1 className="report-main-title">Learning Progress Report</h1>
          <p className="report-main-subtitle">
            Track your performance and achievements across all course levels
          </p>
        </div>
        <div className="report-header-image">
          <img 
            src="/ReportAsset/Report3D.png" 
            alt="Report 3D Icon" 
            className="report-3d-icon"
          />
        </div>
      </div>
    </div>
  );
};

export default ReportHeader;

